// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import Loader from 'react-loader-spinner';
import GlobalStyles from '../../config/styles';

const MyLoader = () => (
  <Loader
    type={'BallTriangle'}
    color={GlobalStyles.color.COLOR_SECONDARY}
    height={80}
    width={80}
  />
);

export default MyLoader;
